import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.AddSubscriptionDialog";
export default defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Add new subscription",
  },
  save: {
    id: `${PREFIX}.save`,
    defaultMessage: "Save",
  },
  cancel: {
    id: `${PREFIX}.cancel`,
    defaultMessage: "Cancel",
  },
});
